import axios from "axios"

export const sendSlackNotification = (message: string, webhookUrl: string) => {
    try {
        axios.post(webhookUrl, JSON.stringify({ text: message }))
    } catch (error) {
        throw new Error(`Slack通知の送信に失敗しました: ${error.message}`)
    }
}
